<nz-tabset nzSize="large" [nzSelectedIndex]="index" [nzAnimated]="false">
  <nz-tab [nzTitle]="'component.sidebar.tab_hour_reservation' | translate">
    <div class="content">
      <host-hour-room-order [data]="data" (success)="onClickCancel()"></host-hour-room-order>
    </div>
  </nz-tab>
</nz-tabset>
